/*
 * TerriSTORY®
 *
 © Copyright 2022 AURA-EE
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * A copy of the GNU Affero General Public License should be present along
 * with this program at the root of current repository. If not, see
 * http://www.gnu.org/licenses/.
 */

import React from "react";
import { buildRegionUrl } from "../../utils.js";
import config from "../../settings.js";
import Api from "../../Controllers/Api.js";

/**
 * This component is used to create an link
 */
class DataTable extends React.Component {
  constructor(props) {
    super(props);
    // we retrieve initial filters
    this.state = {
      name: props.name,
      representation: "pcaet-trajectory-table",
      disabled: false,
      isLoading: false,
      dataTraj: undefined,
      refYear: undefined,
      unit: undefined
    };
  }
  componentDidMount() {
    // Get data from API
    this.fetchConfiguration();
  }
  componentDidUpdate(prevProps) {
    var _this$props$zoneId, _prevProps$zoneId;
    const currentZone = (_this$props$zoneId = this.props.zoneId) !== null && _this$props$zoneId !== void 0 ? _this$props$zoneId : this.props.parentApi.data.currentZone;

    // we find different reasons to retrieve configuration
    if (this.props.id_analysis && (((_prevProps$zoneId = prevProps.zoneId) !== null && _prevProps$zoneId !== void 0 ? _prevProps$zoneId : prevProps.parentApi.data.currentZone) !== currentZone || this.props.id_analysis !== prevProps.id_analysis)) {
      this.fetchConfiguration();
    }
  }
  componentWillUnmount() {
    if (this.dataPromise) {
      this.dataPromise.abort();
      this.props.parentApi.callbacks.updateDataLoaded(true);
    }
  }
  fetchConfiguration() {
    var _this$props$zoneId2, _this$props$zoneType, _this$props$zoneMaill, _this$props$zoneType2;
    let codeInseeTerritoire = (_this$props$zoneId2 = this.props.zoneId) !== null && _this$props$zoneId2 !== void 0 ? _this$props$zoneId2 : this.props.parentApi.data.currentZone;
    let pZone = "?zone=" + ((_this$props$zoneType = this.props.zoneType) !== null && _this$props$zoneType !== void 0 ? _this$props$zoneType : this.props.parentApi.data.zone.zone);
    let pMaille = "&maille=" + ((_this$props$zoneMaill = this.props.zoneMaille) !== null && _this$props$zoneMaill !== void 0 ? _this$props$zoneMaill : this.props.parentApi.data.zone.maille);
    let pZoneId = "&zone_id=" + codeInseeTerritoire;
    if (((_this$props$zoneType2 = this.props.zoneType) !== null && _this$props$zoneType2 !== void 0 ? _this$props$zoneType2 : this.props.parentApi.data.zone.zone) === "region") {
      pZoneId = "&zone_id=" + this.props.parentApi.data.regionCode;
    }
    this.setState({
      isLoading: true
    });
    let dataSource = config.api_pcaet_trajectory_details.replace("#trajectory_id#", this.props.id_analysis) + pZone + pMaille + pZoneId;
    this.props.parentApi.callbacks.updateDataLoaded(false);
    if (this.dataPromise) this.dataPromise.abort();
    this.dataPromise = Api.callApi(buildRegionUrl(dataSource, this.props.parentApi.data.region));
    this.dataPromise.then(json => {
      this.props.parentApi.callbacks.updateDataLoaded(true);
      if (!json) {
        this.setState({
          isLoading: false,
          dataTraj: undefined
        });
        return;
      }
      if (json["disabled"] === true) {
        this.setState({
          disabled: true,
          isLoading: false
        });
        return;
      }
      this.setState({
        dataTraj: json,
        refYear: json["ref_year"],
        unit: json["unit"],
        isLoading: false
      });
    }).catch(error => {
      if (error.name === "AbortError") return;
      this.props.parentApi.callbacks.updateDataLoaded(true);
      this.setState({
        isLoading: false,
        dataTraj: undefined
      });
      console.error(error);
    });
  }
  render() {
    var _this$state$dataTraj;
    if (this.state.disabled) {
      return /*#__PURE__*/React.createElement("div", {
        className: "charts-legende"
      }, /*#__PURE__*/React.createElement("div", {
        className: "confid-chart"
      }, "Cet indicateur n'est pas activ\xE9 actuellement, veuillez contacter l'administrateur r\xE9gional."));
    }
    if (this.state.isLoading) {
      return /*#__PURE__*/React.createElement("div", {
        className: "charts-legende"
      }, /*#__PURE__*/React.createElement("div", {
        className: "loader"
      }));
    }
    if (((_this$state$dataTraj = this.state.dataTraj) === null || _this$state$dataTraj === void 0 ? void 0 : _this$state$dataTraj.pcaet_trajectory) == null) {
      return /*#__PURE__*/React.createElement("div", {
        className: "charts-legende"
      }, /*#__PURE__*/React.createElement("div", {
        className: "confid-chart"
      }, "Aucune donn\xE9e disponible actuellement."));
    }
    let finalArrayColumns = {};
    let totalByColumn = {};
    let finalTableHead = [];
    let finalTableBody = [];
    let columnsHeads = [/*#__PURE__*/React.createElement("th", {
      key: "year"
    }, "Ann\xE9e")];
    let i = 0;
    for (const sectorData of this.state.dataTraj.pcaet_trajectory) {
      columnsHeads.push(/*#__PURE__*/React.createElement("th", {
        key: i
      }, sectorData.nom));
      i++;
      let refValue = undefined,
        evol = undefined;
      for (const data of sectorData.data) {
        if (refValue === undefined) {
          refValue = data.valeur;
        } else if (refValue !== 0) {
          evol = (data.valeur - refValue) / refValue * 100.0;
        }
        if (!finalArrayColumns[data.annee]) {
          finalArrayColumns[data.annee] = [];
          totalByColumn[data.annee] = 0;
        }
        totalByColumn[data.annee] += data.valeur;
        finalArrayColumns[data.annee].push(/*#__PURE__*/React.createElement("td", {
          key: data.annee + "_" + sectorData.nom
        }, new Intl.NumberFormat("fr-FR").format(data.valeur), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
          className: "evol_digit"
        }, evol !== undefined ? /*#__PURE__*/React.createElement(React.Fragment, null, Math.round(evol), "%") : "-")));
      }
    }
    columnsHeads.push(/*#__PURE__*/React.createElement("th", {
      key: i
    }, /*#__PURE__*/React.createElement("strong", null, "Total")));
    finalTableHead.push(/*#__PURE__*/React.createElement("tr", {
      key: "row_heads"
    }, columnsHeads));
    let refValue = undefined,
      evol = undefined;
    for (const year in finalArrayColumns) {
      if (Object.hasOwnProperty.call(finalArrayColumns, year)) {
        const columns = finalArrayColumns[year];
        if (refValue === undefined) {
          refValue = totalByColumn[year];
        } else {
          evol = (totalByColumn[year] - refValue) / refValue * 100.0;
        }
        finalTableBody.push(/*#__PURE__*/React.createElement("tr", {
          key: year
        }, /*#__PURE__*/React.createElement("td", {
          key: "year_column"
        }, year, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
          className: "evol_digit"
        }, year === this.state.refYear ? "année de référence" : "objectif")), columns, /*#__PURE__*/React.createElement("td", {
          key: "total_column"
        }, new Intl.NumberFormat("fr-FR").format(Math.round(totalByColumn[year])), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
          className: "evol_digit"
        }, evol ? /*#__PURE__*/React.createElement(React.Fragment, null, Math.round(evol), "%") : "-"))));
      }
    }
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("table", {
      className: "pcaet_table"
    }, /*#__PURE__*/React.createElement("thead", null, finalTableHead), /*#__PURE__*/React.createElement("tbody", null, finalTableBody)), /*#__PURE__*/React.createElement("p", {
      className: "pcaet_table_legend"
    }, "Objectifs en ", this.state.unit, " et en % par rapport \xE0 l'ann\xE9e de r\xE9f\xE9rence"));
  }
}
export default DataTable;